export default "__VITE_ASSET__NJIc4CG$__"